import { render, staticRenderFns } from "./photo-list-block-edit.vue?vue&type=template&id=5d173762&"
import script from "./photo-list-block-edit.vue?vue&type=script&lang=js&"
export * from "./photo-list-block-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports